import {
  Form,
  Input,
  Select,
  Button,
  Card,
  CardItem,
  H1,
  Icon,
  Spin,
  List,
  Layout,
  DatePicker,
  Row,
  Col,
  Upload,
} from "antd";
import { UserService } from "../../services/user/UserService";
import React, { Component } from "react";
import { showErrorToast, showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./User.css";
import "./CreateUser.css";
import "./Profile.css";
import moment from "moment";
import { CfgUserService } from "../../services/cfgUser/CfgUserService";
import { FileService } from "../../services/file/FileService";
import userAvatar from "../../resource/user.jpg";
import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { HttpService } from "../../utils/HttpService";
import { Constants } from "../../data/constants";


dayjs.extend(customParseFormat);
class Profile extends Component {
  constructor(props) {
    super(props);
    this.httpService = new HttpService();
    this.constants = new Constants();

    this.props.context.setCurrentComponent("profile");
    this.fileService = new FileService();
    this.userService = new UserService();
    this.userCfgService = new CfgUserService();
    this.state = {
      user: {},
      isFetching: false,
      formLayout: "inline",
      file: "",
      imagePreviewUrl: "",
      isImageUpload: false,
      user_lang: "",
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
      fileList: [],
      isDeleteImg: false,
      validateStatus:null
    };
  }

  async componentDidMount() {
    let { user, updateUserImg } = this.props.context;

    await this.setState({ user });
    let response = await this.getUserImg();
    this.setState({ imagePreviewUrl: response ? response : userAvatar });
    if (response) {
      this.setState({
        fileList: [
          {
            uid: "-1",
            status: "done",
            url: response,
          },
        ],
      });
      updateUserImg(response + "");
    } else {
      updateUserImg(userAvatar + "");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  switchLanguage(key) {
    i18next.changeLanguage(key);
    this.props.context.updateLangAndDir(key, key === "en" ? "ltr" : "rtl");
    document.querySelector("html").dir = key === "en" ? "ltr" : "rtl";
    sessionStorage.setItem("dir", key === "en" ? "ltr" : "rtl");
  }

  handleDropdownChange(value) {
    let { user } = this.state;
    user.userType = value;
    this.setState({ user });
  }

  handleLangSwitch(e) {
    this.setState({ user_lang: e });
  }

  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let { updateUser, updateUserImg } = this.props.context;
    let { user } = this.state;
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });

          const selectedDate = values["userBirthdate"]
            .format("YYYY")
            .toString()
            .split("T")[0];
          const todaysDate = dayjs()
            .endOf("day")
            .format("YYYY")
            .toString()
            .split("T")[0];
          if (todaysDate - selectedDate >= 18) {
            values["userBirthdate"] = values["userBirthdate"]
              .format()
              .toString()
              .split("T")[0];
          } else {
            throw new Error(i18next.t("user age must be at least 18"));
          }

          if (this.state.user.userType === "AGENT") {
            values["cfg"] = [
              {
                key: "AGENT_NUMBER",
                value:
                  this.props.context.user.userNumberType !== "alphanumeric" ||
                  this.state.user.userType === "ADMIN"
                    ? values["userNumber"]
                    : values["userNumberA"],
                configCategory: "CTI",
              },
            ];
          } else {
            values["cfg"] = [];
          }
          values["userNumber"] =
            this.props.context.user.userNumberType !== "alphanumeric" ||
            this.state.user.userType === "ADMIN"
              ? values["userNumber"]
              : values["userNumberA"];

          let updatedUser = { ...user, ...values };

          updateUser(updatedUser);
          let request = { ...updatedUser };
          delete request.privilegesList;

          let data = await this.userService.updateProfile(
            this.props.context.session_id,
            request
          );

          if (this.state.isImageUpload) {
            let response = await this.fileService.uploadProfileImg(
              this.props.context.session_id,
              this.state.file
            );
            updateUserImg(this.state.imagePreviewUrl + "");
          } else {
            if (this.state.isDeleteImg) {
              let response = await this.deleteUserImg();
              updateUserImg(userAvatar);
            }
          }

          this.setState({ loading: false });
          showSuccessToast(i18next.t(data.statusMsg));
          this.switchLanguage(values["language"]);
        }
      } catch (e) {
        updateUser(user);
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };
  photoUpload1 = (file) => {
    const reader = new FileReader();

    const validImgs =
      file.type === "image/jpeg" ||
      file.type == "image/png" ||
      file.type == "image/gif";
    if (!validImgs) {
      showErrorToast(i18next.t("You can only upload JPG!"));
      return;
    }
    let position = file.name.lastIndexOf(".");
    let newName =
      this.props.context.user.userId +
      file.name.substring(position, file.name.length);
    const newFile = new File([file], newName, { type: file.type });

    reader.onloadend = () => {
      this.setState({
        file: newFile,
        imagePreviewUrl: reader.result,
        isImageUpload: true,
        fileList: [
          {
            uid: "-1",
            status: "done",
            url: reader.result,
          },
        ],
      });
    };
    reader.readAsDataURL(file);
  };

  photoUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    const validImgs =
      file.type === "image/jpeg" ||
      file.type == "image/png" ||
      file.type == "image/gif";
    if (!validImgs) {
      showErrorToast(i18next.t("You can only upload JPG!"));
      return;
    }
    let position = file.name.lastIndexOf(".");
    let newName =
      this.props.context.user.userId +
      file.name.substring(position, file.name.length);
    const newFile = new File([file], newName, { type: file.type });

    reader.onloadend = () => {
      this.setState({
        file: newFile,
        imagePreviewUrl: reader.result,
        isImageUpload: true,
        fileList: [
          {
            uid: "-1",
            status: "done",
            url: reader.result,
          },
        ],
      });
    };
    reader.readAsDataURL(file);
  };

  async getUserImg() {
    let session_id = this.props.context.session_id;
    let user_id = this.props.context.user.userId;
    try {
      return await this.fileService.getUserImg(session_id, user_id);
    } catch (e) {
      return null;
    }
  }
  async deleteUserImg() {
    let session_id = this.props.context.session_id;
    let user_id = this.props.context.user.userId;
    try {
      return await this.fileService.deleteUserImg(session_id, user_id);
    } catch (e) {
      return null;
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { Option } = Select;
    let { isFetching, imagePreviewUrl } = this.state;
    const imageUrl = userAvatar;
    const uploadButton = (
      <label className="custom-file-upload fas">
        <div
          className="img-wrap img-upload"
          style={{ width: "180px", height: "180px", borderRadius: "50%" }}
        >
          <img src={userAvatar} className="profile-pic" />
        </div>
        <input id="photo-upload" type="file" onChange={this.photoUpload} />
      </label>
    );
    const ImgUpload = ({ onChange, src }) => (
      // <label className="custom-file-upload fas">
      //   <div className="img-wrap img-upload">
      //     <img src={src} className="profile-pic" />
      //   </div>
      //   <input id="photo-upload" type="file" onChange={onChange} />
      // </label>
      <div className="img-wrap">
        {this.state.fileList.length > 0 ? (
          <Upload
            listType="picture-card"
            fileList={this.state.fileList}
            onRemove={() => {
              this.setState({ fileList: [] });
              this.setState({ isImageUpload: false });
              this.setState({ isDeleteImg: true });
            }}
            onDownload={() => {}}
          ></Upload>
        ) : (
          uploadButton
        )}
      </div>
    );
    const disabledDate = (current) => {
      // Can not select days after today
      return current > dayjs().endOf("day");
    };
    return (
      <Translation>
        {(t) => (
          <Page title={t("Profile")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <div className="div-img">
                  <ImgUpload src={imagePreviewUrl} />
                </div>

                <Form className="form-style" {...formItemLayout}>
                  <Form.Item label={t("Email")} {...formItemLayout}>
                    {getFieldDecorator("userEmail", {
                      initialValue: this.state.user.userEmail,
                      rules: [
                        {
                          type: "email",
                          message: t("The input is not valid E-mail!"),
                        },
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user email"),
                        },
                      ],
                    })(<Input disabled={this.state.user.userType=='AGENT'}/>)}
                  </Form.Item>

                  <Form.Item label={t("Full Name")} {...formItemLayout}>
                    {getFieldDecorator(
                      "userFullname",

                      {
                        initialValue: this.state.user.userFullname,

                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: true,
                            message: t("Please enter user full name"),
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("Birthdate")} {...formItemLayout}>
                    {getFieldDecorator("userBirthdate", {
                      initialValue: moment(
                        this.state.user.userBirthdate,
                        "YYYY-MM-DD"
                      ),
                      rules: [
                        {
                          required: true,
                          message: t("Please enter user birthdate"),
                        },
                      ],
                    })(
                      <DatePicker
                        disabledDate={disabledDate}
                        locale={this.state.lang === "ar" ? ar : en}
                      />
                    )}
                  </Form.Item>

                  <Form.Item label={t("Gender")} {...formItemLayout}>
                    {getFieldDecorator("userGender", {
                      initialValue: this.state.user.userGender,
                      rules: [
                        {
                          required: true,
                          message: t("Please select user gender"),
                        },
                      ],
                    })(
                      <Select
                        placeholder={t("Select ")}
                        onChange={this.handleSelectChange}
                      >
                        <Option value="M">{t("Male")}</Option>
                        <Option value="F">{t("Female")}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label={t("User Name")} {...formItemLayout}>
                    {getFieldDecorator("userName", {
                      initialValue: this.state.user.userName,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user name"),
                        },
                      ],
                    })(<Input  disabled={this.state.user.userType=='AGENT'} />)}
                  </Form.Item>

                  <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType ===
                          "alphanumeric" && this.state.user.userType !== "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("userNumberA", {
                      initialValue:
                        this.props.context.user.userNumberType ===
                          "alphanumeric" && this.state.user.userType !== "ADMIN"
                          ? this.state.user.userNumber
                          : "",
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                          pattern: "^[a-zA-Z0-9_@$.*]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType ===
                              "alphanumeric" &&
                            this.state.user.userType !== "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter user number"),
                        },
                      ],
                    })(<Input  disabled={this.state.user.userType=='AGENT'}/>)}
                  </Form.Item>

                  {/* <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("userNumber", {
                      initialValue:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? this.state.user.userNumber
                          : "",
                      rules: [
                        {
                          type: "string",
                          message: t("Mobile number is not valid "),
                          min: 12,
                          max: 12,
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType !==
                              "alphanumeric" ||
                            this.state.user.userType === "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter mobile number"),
                        },
                      ],
                    })(<Input maxLength={12} placeholder="201XXXXXXXXX" />)}
                  </Form.Item> */}

                  <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                    validateStatus={this.state.validateStatus}
                    help={
                      this.state.validateStatus == "error"
                        ? "Mobile number is not valid"
                        : ""
                    }
                    hasFeedback={this.state.validateStatus}
                  >


{getFieldDecorator("userNumber", {
                      initialValue: this.state.user.userNumber,
                      rules: [
                        {
                          type: "string",
                          message: t("Mobile number is not valid"),
                          min: 12,
                          max: 12,
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType !==
                              "alphanumeric" ||
                            this.state.user.userType === "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter user number"),
                        },
                      ],
                    })(
                      <Input
                      disabled={this.state.user.userType=='AGENT'}
                        maxLength={12}
                        placeholder="201XXXXXXXXX"
                        id="validating"
                        onChange={async (e) => {
                          if (
                            !/^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(
                              e.target.value
                            ) ||
                            e.target.value.length < 12
                          ) {
                            this.setState({ validateStatus: "error" });
                            return;
                          }
                          if(!this.constants.TESTING){
                          if (e.target.value.length == 12) {
                            this.setState({ validateStatus: "validating" });
                            let response =  await this.userService.validateUserNumber(this.props.context.session_id,e.target.value)
                            if (response == null) {
                              this.setState({ validateStatus: "error" });
                            } else {
                              if (response.exceptionCode == 0 || response.exceptionCode=="0") {
                                this.setState({ validateStatus: "success" });
                              } else {
                                this.setState({ validateStatus: "error" });
                              }
                            }
                          }
                          }else{
                            this.setState({ validateStatus: "success" });

                          }
                        }}
                      />
                    )}
                    </Form.Item>

                  {/* {this.state.user.userType !== "CARE" && ( */}
                    <Form.Item label={t("Type")} {...formItemLayout}>
                      <label>{t(this.state.user.userType)} </label>
                    </Form.Item>
                  {/* )} */}
                  <Form.Item label={t("Language")} {...formItemLayout}>
                    {getFieldDecorator("language", {
                      initialValue: this.state.user.language
                        ? this.state.user.language
                        : this.props.context.curr_lang,
                      rules: [
                        {
                          required: false,
                        },
                      ],
                    })(
                      <Select
                        defaultValue={
                          this.props.context.curr_lang === "en"
                            ? "English"
                            : "اللغة العربية"
                        }
                        onChange={(e) => this.handleLangSwitch(e)}
                      >
                        <Option value="en">English</Option>
                        <Option value="ar">اللغة العربية</Option>
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                      disabled={this.state.validateStatus == "error" || this.state.validateStatus == "validating"}

                    >
                      {t("Update")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(Profile)));
